"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[345],{

/***/ 8345:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


const FaqPage = function(){
    if( window.location.hash ){
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window.location.hash).trigger('click');
    }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FaqPage);


/***/ })

}]);